module.exports = __webpack_public_path__ + "img/Country3-1.383e7f2c.png";